import React, { lazy, Suspense } from "react";

import HomePage from "./Pages/HomePage";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Media from "./Pages/Media";
import AdminMain from './AdminPanel.js/AdminMain'
import SignInPage from "./AdminPanel.js/SignInpage";
import { AuthProvider } from "./AuthContext";

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const Blog = lazy(() => import('./Pages/Blog'));
const BlogPost = lazy(() => import('./Pages/BlogPost'));

const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();

  return currentUser ? children : <Navigate to="/admin" />;
};
function App() {
  return (
    <AuthProvider>
      <Router>
  <Suspense fallback={<p role="status" className="p-10 text-center text-slate-600">Loading…</p>}>
  <Routes>
    <Route path="/" element={<HomePage />} /> 
    <Route path="/AboutUS" element={<AboutUs/>} /> 
    <Route path="/ContactUS" element={<ContactUs/>} /> 
    <Route path="/privacy-policy" element={<PrivacyPolicy/>} /> 
    <Route path="/Media" element={<Media/>} />
    <Route path="/Blog" element={<Blog/>} />
    <Route path="/Blog/:language/:slug" element={<BlogPost/>} />
    <Route
  path="/adminsection"
  element={
    <PrivateRoute>
      <AdminMain />
    </PrivateRoute>
  }
/>
    <Route path="/admin" element={<SignInPage/>} /> 
  </Routes>
  </Suspense>
 </Router>
    </AuthProvider>
  
  );
}

export default App;


